/** @jsx jsx */
import { jsx } from '@emotion/react'
import styled from '@emotion/styled';

export const NameTagDiv = styled('div')({
  position: 'absolute',
  bottom: '8px',
  paddingLeft: '2px',
  paddingRight: '2px',
  paddingTop: '0px',
  paddingBottom: '0px',
  background: 'rgba(160,160,160, 0.6)',
  color: 'black',
});
